"use strict";

module.exports = {
    "debug": false, /* 调试开关 */
    "bridgeReadyEvent": "WebViewJavascriptBridgeReady", /* Hytive 桥 Ready 事件 */
    "bridgeReadyTimeout": 600, /* 桥 Ready 最大延迟 */
    "apiTimeout": 1000, /* API 超时时间 */
    "hytiveReg": "", /* Hytive UA 判断正则 */
    "wechatSupport": false, /* 是否支持微信 */
    "wechatScriptUrl": "//res.wx.qq.com/open/js/jweixin-1.0.0.js", /* 微信 JSSDK 地址 */
    "wechatSignatureUrl": "" /* 微信签名服务地址 */
};


//////////////////
// WEBPACK FOOTER
// ../src/config.js
// module id = 30
// module chunks = 0 2 4